import { useCallback } from 'react';
import { firebaseLogEvent } from '@/lib/firebase/firebase';
import { FirebaseAnalyticsEvent } from "@/lib/firebase/types";

export const useFirebaseAnalytics = () => {
	const logEvent = useCallback(
		(
			eventName: FirebaseAnalyticsEvent,
			eventPayload?: Record<string, unknown>
		) => {
			if (import.meta.env.DEV) {
				console.log(`[Analytics] ${eventName}`, eventPayload || '');
			} else {
				firebaseLogEvent(eventName, eventPayload);
			}
	}, []);

	const logEventToAccount = useCallback((type: 'button_top' | 'button_bottom') => {
		logEvent(FirebaseAnalyticsEvent.CLICK_TO_ACCOUNT, { type });
	}, [logEvent]);

	const logEventDownloadAppStore = useCallback((type: 'button_top' | 'button_middle' | 'button_bottom') => {
		logEvent(FirebaseAnalyticsEvent.CLICK_APPSTORE, { type });
	}, [logEvent]);

	const logEventDownloadApk = useCallback((type: 'button_top' | 'button_middle' | 'button_bottom') => {
		logEvent(FirebaseAnalyticsEvent.CLICK_ANDROID, { type });
	}, [logEvent]);

	return {
		logEvent,
		logEventToAccount,
		logEventDownloadAppStore,
		logEventDownloadApk
	};
};
